(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aspadz-col-promos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aspadz-collection-promo-cards')) {
    class AspadzCollectionPromoCards extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;

        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.addEventListener('click', this.onControllerClick.bind(this), { signal });
        this.querySelectorAll('[data-aspadz-cpc-popup]').forEach((dialog) => {
          dialog.addEventListener('cancel', this.onDialogCancel.bind(this), { signal });
          dialog.addEventListener('close', this.onDialogClose.bind(this), { signal });
          dialog.addEventListener('click', this.onDialogClick.bind(this), { signal });
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;

        this.querySelectorAll('[data-aspadz-cpc-popup][open]').forEach((dialog) => dialog.close());
        this.activeDialog = null;
        this.activeTrigger = null;
        this.restoreFocusOnClose = false;
        this.releaseScrollLock();
      }

      onControllerClick(event) {
        const trigger = event.target.closest('[data-aspadz-cpc-popup-trigger]');
        if (trigger && this.contains(trigger)) {
          const dialogId = trigger.getAttribute('aria-controls');
          const dialog = dialogId ? document.getElementById(dialogId) : null;
          if (dialog && this.contains(dialog)) this.openDialog(dialog, trigger);
          return;
        }

        const closeButton = event.target.closest('[data-aspadz-cpc-popup-close]');
        if (closeButton && this.contains(closeButton)) {
          this.closeDialog(closeButton.closest('[data-aspadz-cpc-popup]'));
        }
      }

      onDialogCancel(event) {
        event.preventDefault();
        this.closeDialog(event.currentTarget);
      }

      onDialogClick(event) {
        const dialog = event.currentTarget;
        if (event.target !== dialog) return;

        const rect = dialog.getBoundingClientRect();
        const isBackdropClick =
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom;

        if (isBackdropClick) this.closeDialog(dialog);
      }

      onDialogClose(event) {
        const dialog = event.currentTarget;
        const focusTarget = this.restoreFocusOnClose ? this.activeTrigger : null;

        if (this.activeDialog === dialog) this.activeDialog = null;
        this.activeTrigger = null;
        this.restoreFocusOnClose = false;
        this.releaseScrollLock();

        if (focusTarget && focusTarget.isConnected) {
          requestAnimationFrame(() => focusTarget.focus({ preventScroll: true }));
        }
      }

      openDialog(dialog, trigger) {
        if (this.activeDialog && this.activeDialog !== dialog) {
          this.closeDialog(this.activeDialog, false);
        }

        this.activeDialog = dialog;
        this.activeTrigger = trigger;
        this.restoreFocusOnClose = true;

        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('aspadz-cpc-popup-open');

        requestAnimationFrame(() => {
          dialog.querySelector('[data-aspadz-cpc-popup-close]')?.focus({ preventScroll: true });
        });
      }

      closeDialog(dialog, restoreFocus = true) {
        if (!dialog || !dialog.open) return;
        this.restoreFocusOnClose = restoreFocus;
        dialog.close();
      }

      releaseScrollLock() {
        if (!document.querySelector('[data-aspadz-cpc-popup][open]')) {
          document.documentElement.classList.remove('aspadz-cpc-popup-open');
        }
      }
    }

    customElements.define('aspadz-collection-promo-cards', AspadzCollectionPromoCards);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aspadz-new-collection"] && !Shopify.designMode) return;
  try {
    
  class AspadzNewCollection extends HTMLElement {
    connectedCallback() {
      document.documentElement.classList.add('aspadz-new-collection-page');
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.boundHandleClick = this.handleClick.bind(this);
      this.boundHandleChange = this.handleChange.bind(this);
      this.boundHandleSubmit = this.handleSubmit.bind(this);
      this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.filterDrawer = this.querySelector('[data-aspadz-new-collection-filter-drawer]');
      this.sortModal = this.querySelector('[data-aspadz-new-collection-sort-modal]');
      this.sortDropdown = this.querySelector('[data-aspadz-new-collection-sort-dropdown]');
      this.sidebarToggle = this.querySelector('[data-aspadz-new-collection-sidebar-toggle]');
      this.sidebarPanel = this.querySelector('[data-aspadz-new-collection-sidebar-panel]');
      this.portalFilterDrawer();
      this.portalSortModal();

      this.addEventListener('click', this.boundHandleClick);
      this.addEventListener('change', this.boundHandleChange);
      this.addEventListener('submit', this.boundHandleSubmit);
      if (this.filterDrawer) {
        this.filterDrawer.addEventListener('click', this.boundHandleClick);
        this.filterDrawer.addEventListener('change', this.boundHandleChange);
        this.filterDrawer.addEventListener('submit', this.boundHandleSubmit);
      }
      if (this.sortModal) {
        this.sortModal.addEventListener('click', this.boundHandleClick);
        this.sortModal.addEventListener('submit', this.boundHandleSubmit);
      }
      document.addEventListener('keydown', this.handleDocumentKeydown);
      document.addEventListener('click', this.handleDocumentClick);
      this.setSidebarCollapsed(false);
      this.syncFilterChipStates();
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.handleDocumentKeydown);
      document.removeEventListener('click', this.handleDocumentClick);
      if (this.filterDrawer) {
        this.filterDrawer.removeEventListener('click', this.boundHandleClick);
        this.filterDrawer.removeEventListener('change', this.boundHandleChange);
        this.filterDrawer.removeEventListener('submit', this.boundHandleSubmit);
        this.filterDrawer.remove();
      }
      if (this.sortModal) {
        this.sortModal.removeEventListener('click', this.boundHandleClick);
        this.sortModal.removeEventListener('submit', this.boundHandleSubmit);
        this.sortModal.remove();
      }
      this.classList.remove('is-filter-open');
      this.classList.remove('is-sort-open');
      this.closeSortDropdown();
      if (!document.querySelector('aspadz-new-collection')) {
        document.documentElement.classList.remove('aspadz-new-collection-page');
        document.documentElement.classList.remove('aspadz-new-collection-filter-open');
        document.documentElement.classList.remove('aspadz-new-collection-modal-open');
      }
    }

    handleClick(event) {
      const sidebarToggle = event.target.closest('[data-aspadz-new-collection-sidebar-toggle]');
      if (sidebarToggle) {
        this.toggleSidebar();
        return;
      }

      const sortDropdownTrigger = event.target.closest('[data-aspadz-new-collection-sort-dropdown-trigger]');
      if (sortDropdownTrigger) {
        this.toggleSortDropdown(sortDropdownTrigger);
        return;
      }

      const filterButton = event.target.closest('[data-aspadz-new-collection-filter]');
      if (filterButton) {
        this.openFilterDrawer(filterButton);
        return;
      }

      const sortTrigger = event.target.closest('[data-aspadz-new-collection-sort-trigger]');
      if (sortTrigger) {
        this.openSortModal(sortTrigger);
        return;
      }

      const sortCloseButton = event.target.closest('[data-aspadz-new-collection-sort-close]');
      if (sortCloseButton) {
        this.closeSortModal();
        return;
      }

      const closeButton = event.target.closest('[data-aspadz-new-collection-filter-close]');
      if (closeButton) {
        this.closeFilterDrawer({ reset: true });
        return;
      }

      const moreButton = event.target.closest('[data-aspadz-new-collection-more-toggle]');
      if (moreButton) {
        this.toggleMore(moreButton);
        return;
      }

      const swatch = event.target.closest('[data-aspadz-new-collection-swatch]');
      if (!swatch) return;

      const card = swatch.closest('[data-aspadz-new-collection-card]');
      if (!card) return;

      this.activateSwatch(card, swatch);
    }

    handleChange(event) {
      const filterInput = event.target.closest('.aspadz-new-collection__filter-input');
      if (filterInput) {
        this.syncFilterChipStates();
        if (this.shouldAutoSubmitFilter(filterInput)) {
          this.submitFilterForm(filterInput.form);
        }
        return;
      }

      const priceInput = event.target.closest('[data-aspadz-new-collection-emptyable]');
      if (priceInput && this.shouldAutoSubmitFilter(priceInput)) {
        this.submitFilterForm(priceInput.form);
        return;
      }

      const sort = event.target.closest('[data-aspadz-new-collection-sort]');
      if (!sort || !sort.form) return;
      sort.form.submit();
    }

    handleDocumentClick(event) {
      const dropdown = this.getSortDropdown();
      if (!dropdown || !dropdown.classList.contains('is-open')) return;
      if (dropdown.contains(event.target)) return;
      this.closeSortDropdown();
    }

    handleSubmit(event) {
      const form = event.target.closest('[data-aspadz-new-collection-filter-form]');
      if (!form) return;

      this.prepareFilterForm(form);
    }

    prepareFilterForm(form) {
      form.querySelectorAll('[data-aspadz-new-collection-emptyable]').forEach((input) => {
        if (input.value.trim() === '') {
          input.disabled = true;
        }
      });
    }

    shouldAutoSubmitFilter(input) {
      return Boolean(input && input.form && input.closest('.aspadz-new-collection__filter-inline'));
    }

    submitFilterForm(form) {
      if (!form) return;
      this.prepareFilterForm(form);
      form.submit();
    }

    handleDocumentKeydown(event) {
      if (event.key !== 'Escape') return;
      const sortModal = this.getSortModal();
      if (sortModal && !sortModal.hidden) {
        this.closeSortModal();
        return;
      }

      const dropdown = this.getSortDropdown();
      if (dropdown && dropdown.classList.contains('is-open')) {
        this.closeSortDropdown({ restoreFocus: true });
        return;
      }

      const drawer = this.getFilterDrawer();
      if (!drawer || drawer.hidden) return;
      this.closeFilterDrawer({ reset: true });
    }

    getFilterDrawer() {
      return this.filterDrawer || document.querySelector('[data-aspadz-new-collection-filter-drawer]');
    }

    getSortDropdown() {
      return this.sortDropdown || this.querySelector('[data-aspadz-new-collection-sort-dropdown]');
    }

    syncModalCssVariables(target) {
      if (!target) return;
      const computedStyle = window.getComputedStyle(this);
      [
        '--aspadz-nc-bg',
        '--aspadz-nc-card-bg',
        '--aspadz-nc-text',
        '--aspadz-nc-dark',
        '--aspadz-nc-muted',
        '--aspadz-nc-subtle',
        '--aspadz-nc-accent',
        '--aspadz-nc-button-text',
      ].forEach((property) => {
        target.style.setProperty(property, computedStyle.getPropertyValue(property));
      });
    }

    portalFilterDrawer() {
      const drawer = this.getFilterDrawer();
      if (!drawer) return;

      this.syncModalCssVariables(drawer);

      if (drawer.parentElement !== document.body) {
        document.body.appendChild(drawer);
      }
    }

    getSortModal() {
      return this.sortModal || document.querySelector('[data-aspadz-new-collection-sort-modal]');
    }

    portalSortModal() {
      const modal = this.getSortModal();
      if (!modal) return;

      this.syncModalCssVariables(modal);

      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    }

    openFilterDrawer(trigger) {
      this.portalFilterDrawer();
      const drawer = this.getFilterDrawer();
      if (!drawer) return;

      this.closeSortModal({ restoreFocus: false });
      this.closeSortDropdown();

      window.clearTimeout(this.filterDrawerTimer);
      this.activeFilterTrigger = trigger;
      drawer.hidden = false;
      this.classList.add('is-filter-open');
      document.documentElement.classList.add('aspadz-new-collection-filter-open');
      this.querySelectorAll('[data-aspadz-new-collection-filter]').forEach((button) => {
        button.setAttribute('aria-expanded', 'true');
      });

      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
        const focusTarget = drawer.querySelector('[data-aspadz-new-collection-filter-close]');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      });
    }

    closeFilterDrawer({ reset = true } = {}) {
      const drawer = this.getFilterDrawer();
      if (!drawer || drawer.hidden) return;

      if (reset) {
        const form = drawer.querySelector('[data-aspadz-new-collection-filter-form]');
        if (form) {
          form.reset();
          form.querySelectorAll('[data-aspadz-new-collection-emptyable]').forEach((input) => {
            input.disabled = false;
          });
          this.resetMoreLists(drawer);
          this.syncFilterChipStates();
        }
      }

      drawer.classList.remove('is-open');
      this.classList.remove('is-filter-open');
      document.documentElement.classList.remove('aspadz-new-collection-filter-open');
      this.querySelectorAll('[data-aspadz-new-collection-filter]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });

      this.filterDrawerTimer = window.setTimeout(() => {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 220);

      if (this.activeFilterTrigger) {
        this.activeFilterTrigger.focus({ preventScroll: true });
      }
    }

    openSortModal(trigger) {
      this.portalSortModal();
      const modal = this.getSortModal();
      if (!modal) return;

      this.closeFilterDrawer({ reset: true });
      this.closeSortDropdown();

      window.clearTimeout(this.sortModalTimer);
      this.activeSortTrigger = trigger;
      modal.hidden = false;
      this.classList.add('is-sort-open');
      document.documentElement.classList.add('aspadz-new-collection-modal-open');
      this.querySelectorAll('[data-aspadz-new-collection-sort-trigger]').forEach((button) => {
        button.setAttribute('aria-expanded', 'true');
      });

      requestAnimationFrame(() => {
        modal.classList.add('is-open');
        const focusTarget = modal.querySelector('.aspadz-new-collection__sort-option.is-active') || modal.querySelector('.aspadz-new-collection__sort-panel');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      });
    }

    closeSortModal({ restoreFocus = true } = {}) {
      const modal = this.getSortModal();
      if (!modal || modal.hidden) return;

      modal.classList.remove('is-open');
      this.classList.remove('is-sort-open');
      document.documentElement.classList.remove('aspadz-new-collection-modal-open');
      this.querySelectorAll('[data-aspadz-new-collection-sort-trigger]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });

      this.sortModalTimer = window.setTimeout(() => {
        if (!modal.classList.contains('is-open')) modal.hidden = true;
      }, 220);

      if (restoreFocus && this.activeSortTrigger) {
        this.activeSortTrigger.focus({ preventScroll: true });
      }
    }

    toggleSortDropdown(trigger) {
      const dropdown = trigger.closest('[data-aspadz-new-collection-sort-dropdown]');
      if (!dropdown) return;

      if (dropdown.classList.contains('is-open')) {
        this.closeSortDropdown({ restoreFocus: true });
        return;
      }

      this.openSortDropdown(dropdown, trigger);
    }

    openSortDropdown(dropdown, trigger) {
      this.closeFilterDrawer({ reset: true });
      this.closeSortModal({ restoreFocus: false });

      const menu = dropdown.querySelector('[data-aspadz-new-collection-sort-dropdown-menu]');
      if (!menu) return;

      this.activeSortDropdownTrigger = trigger;
      dropdown.classList.add('is-open');
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');

      const activeOption = menu.querySelector('.aspadz-new-collection__sort-dropdown-option.is-active');
      if (activeOption) activeOption.focus({ preventScroll: true });
    }

    closeSortDropdown({ restoreFocus = false } = {}) {
      const dropdown = this.getSortDropdown();
      if (!dropdown) return;

      const trigger = dropdown.querySelector('[data-aspadz-new-collection-sort-dropdown-trigger]');
      const menu = dropdown.querySelector('[data-aspadz-new-collection-sort-dropdown-menu]');

      dropdown.classList.remove('is-open');
      if (menu) menu.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');

      if (restoreFocus && this.activeSortDropdownTrigger) {
        this.activeSortDropdownTrigger.focus({ preventScroll: true });
      }
    }

    toggleSidebar() {
      this.closeSortDropdown();
      this.setSidebarCollapsed(!this.classList.contains('is-sidebar-collapsed'));
    }

    setSidebarCollapsed(isCollapsed) {
      this.classList.toggle('is-sidebar-collapsed', isCollapsed);

      this.querySelectorAll('[data-aspadz-new-collection-sidebar-toggle]').forEach((button) => {
        button.setAttribute('aria-expanded', isCollapsed ? 'false' : 'true');
      });

      if (!this.sidebarPanel) return;

      this.sidebarPanel.setAttribute('aria-hidden', isCollapsed ? 'true' : 'false');
      if (isCollapsed) {
        this.sidebarPanel.setAttribute('inert', '');
        if (this.sidebarPanel.contains(document.activeElement) && this.sidebarToggle) {
          this.sidebarToggle.focus({ preventScroll: true });
        }
      } else {
        this.sidebarPanel.removeAttribute('inert');
      }
    }

    resetMoreLists(root) {
      root.querySelectorAll('[data-aspadz-new-collection-more-list].is-expanded').forEach((list) => {
        list.classList.remove('is-expanded');
      });

      root.querySelectorAll('[data-aspadz-new-collection-more-toggle]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');

        const sign = button.querySelector('.aspadz-new-collection__filter-more-sign');
        if (sign) sign.textContent = '+';

        const text = button.querySelector('[data-aspadz-new-collection-more-text]');
        if (text) text.textContent = button.dataset.moreLabel || 'More';
      });
    }

    toggleMore(button) {
      const content = button.closest('.aspadz-new-collection__filter-content');
      const list = content ? content.querySelector('[data-aspadz-new-collection-more-list]') : null;
      if (!list) return;

      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const nextExpanded = !isExpanded;
      list.classList.toggle('is-expanded', nextExpanded);
      button.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');

      const sign = button.querySelector('.aspadz-new-collection__filter-more-sign');
      if (sign) sign.textContent = nextExpanded ? '-' : '+';

      const text = button.querySelector('[data-aspadz-new-collection-more-text]');
      if (text) {
        text.textContent = nextExpanded ? button.dataset.lessLabel || 'Less' : button.dataset.moreLabel || 'More';
      }
    }

    syncFilterChipStates() {
      const drawer = this.getFilterDrawer();
      const roots = [this];
      if (drawer) roots.push(drawer);

      roots.forEach((root) => {
        root.querySelectorAll('.aspadz-new-collection__filter-chip').forEach((chip) => {
          const input = chip.querySelector('.aspadz-new-collection__filter-input');
          if (!input) return;
          chip.classList.toggle('is-active', input.checked);
          chip.classList.toggle('is-checked', input.checked);
        });
      });
    }

    getVariants(card) {
      const script = card.querySelector('[data-aspadz-new-collection-variants]');
      if (!script) return [];

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return [];
      }
    }

    getSelectedOptions(card) {
      const selectedOptions = [];
      card.querySelectorAll('[data-aspadz-new-collection-swatch][aria-pressed="true"]').forEach((swatch) => {
        selectedOptions[Number(swatch.dataset.optionIndex)] = swatch.dataset.optionValue;
      });
      return selectedOptions;
    }

    findVariant(card, swatch) {
      const variants = this.getVariants(card);
      const selectedOptions = this.getSelectedOptions(card);
      selectedOptions[Number(swatch.dataset.optionIndex)] = swatch.dataset.optionValue;

      return variants.find((variant) => {
        return variant.options.every((option, index) => {
          return selectedOptions[index] === undefined || selectedOptions[index] === option;
        });
      });
    }

    activateSwatch(card, swatch) {
      const variant = this.findVariant(card, swatch);
      if (!variant) return;

      card.querySelectorAll('[data-aspadz-new-collection-swatch]').forEach((item) => {
        const sameOption = item.dataset.optionIndex === swatch.dataset.optionIndex;
        if (!sameOption) return;
        item.setAttribute('aria-pressed', item === swatch ? 'true' : 'false');
      });

      const image = card.querySelector('.aspadz-new-collection__image');
      if (image && variant.image) {
        image.src = variant.image;
        image.removeAttribute('srcset');
      }

      card.querySelectorAll('[data-aspadz-new-collection-link]').forEach((link) => {
        if (variant.url) link.href = variant.url;
      });

      const price = card.querySelector('[data-aspadz-new-collection-price]');
      if (price) price.textContent = variant.price || '';

      const comparePrice = card.querySelector('[data-aspadz-new-collection-compare-price]');
      if (comparePrice) comparePrice.textContent = variant.comparePrice || '';

      this.updatePromoBadges(card, variant.saleBadgeText || '');

      const variantInput = card.querySelector('.product-variant-id');
      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.disabled = !variant.available;
      }

      const submitButton = card.querySelector('.product-form__submit');
      if (submitButton) {
        submitButton.disabled = !variant.available;
        submitButton.toggleAttribute('aria-disabled', !variant.available);
      }
    }

    updatePromoBadges(card, saleBadgeText) {
      const wrapper = card.querySelector('[data-aspadz-product-promo-badges]');
      const saleBadge = wrapper?.querySelector('[data-aspadz-product-promo-sale]');
      const promoCard = wrapper?.querySelector('[data-aspadz-product-promo-card]');
      if (!wrapper || !saleBadge) return;

      const hasSaleBadge = Boolean(saleBadgeText);
      const hasPromoCard = Boolean(promoCard && !promoCard.hidden);

      saleBadge.textContent = saleBadgeText;
      saleBadge.hidden = !hasSaleBadge;
      wrapper.hidden = !hasSaleBadge && !hasPromoCard;
      wrapper.classList.toggle('aspadz-product-promo-badges--card-only', !hasSaleBadge && hasPromoCard);
    }
  }

  if (!customElements.get('aspadz-new-collection')) {
    customElements.define('aspadz-new-collection', AspadzNewCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aspadz-prod-comfort"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const BUTTON_SELECTOR = "[data-before-after-images-button]";
    const SEPARATOR_SELECTOR = "[data-before-after-images-separator]";
    const STEP = 20;
    const WITH_TRANSITION_CLASS = "before-after--with-transition";
    const isLeftKey = (event) => event.key === "ArrowLeft" || event.key === "Left";
    const isRightKey = (event) => event.key === "ArrowRight" || event.key === "Right";

    if (customElements.get("before-after-images")) return;

    class BeforeAfterImages extends HTMLElement {
      constructor() {
        super();
        this.isMoving = false;
        this.handleInViewport = this.handleInViewport.bind(this);
        this.handleButtonKeyUp = this.handleButtonKeyUp.bind(this);
        this.handleButtonMouseDown = this.handleButtonMouseDown.bind(this);
        this.handleButtonMouseUp = this.handleButtonMouseUp.bind(this);
        this.handleMouseMove = this.handleMouseMove.bind(this);
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
        this.handleTouchMove = this.handleTouchMove.bind(this);
      }

      connectedCallback() {
        if (this.beforeAfterImagesReady) return;
        this.beforeAfterImagesReady = true;
        this.button = this.querySelector(BUTTON_SELECTOR);
        this.separator = this.querySelector(SEPARATOR_SELECTOR);
        if (!this.button) return;
        this.button.addEventListener("keyup", this.handleButtonKeyUp);
        this.button.addEventListener("mousedown", this.handleButtonMouseDown);
        document.addEventListener("mouseup", this.handleButtonMouseUp);
        document.addEventListener("mousemove", this.handleMouseMove);
        this.button.addEventListener("touchstart", this.handleTouchStart);
        this.addEventListener("touchmove", this.handleTouchMove, { passive: false });
        document.addEventListener("touchend", this.handleTouchEnd);
        if ("IntersectionObserver" in window) {
          this.intersectionObserver = new IntersectionObserver(this.handleInViewport, { rootMargin: "0px" });
          this.intersectionObserver.observe(this);
        } else {
          this.setInitialPosition();
        }
      }

      disconnectedCallback() {
        if (!this.button) return;
        this.button.removeEventListener("keyup", this.handleButtonKeyUp);
        this.button.removeEventListener("mousedown", this.handleButtonMouseDown);
        document.removeEventListener("mouseup", this.handleButtonMouseUp);
        document.removeEventListener("mousemove", this.handleMouseMove);
        this.button.removeEventListener("touchstart", this.handleTouchStart);
        this.removeEventListener("touchmove", this.handleTouchMove);
        document.removeEventListener("touchend", this.handleTouchEnd);
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
      }

      transitionToPromise(element) {
        return new Promise((resolve) => {
          if (!element) {
            resolve();
            return;
          }
          let isResolved = false;
          const finish = () => {
            if (isResolved) return;
            isResolved = true;
            element.removeEventListener("transitionend", finish);
            resolve();
          };
          element.addEventListener("transitionend", finish, { once: true });
          window.setTimeout(finish, 1200);
        });
      }

      async setInitialPosition() {
        const initialPosition = Number(this.dataset.initialDragPosition);
        this.setPosition(Number.isFinite(initialPosition) ? initialPosition : 100);
        await this.transitionToPromise(this.separator);
        this.classList.remove(WITH_TRANSITION_CLASS);
      }

      handleInViewport(entries) {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.intersectionObserver.disconnect();
          this.setInitialPosition();
        }
      }

      handleButtonMouseDown(event) {
        event.preventDefault();
        this.startMove();
      }

      handleButtonMouseUp() {
        this.endMove();
      }

      handleMouseMove(event) {
        if (this.isMoving) this.move(event.pageX);
      }

      handleButtonKeyUp(event) {
        const button = this.button;
        if (!button || (!isLeftKey(event) && !isRightKey(event))) return;
        const rect = button.getBoundingClientRect();
        const point = rect.right - rect.width / 2;
        const position = isLeftKey(event) ? point - STEP : point + STEP;
        this.move(position);
      }

      handleTouchStart() {
        this.startMove();
      }

      handleTouchEnd() {
        this.endMove();
      }

      handleTouchMove(event) {
        if (this.isMoving) {
          event.preventDefault();
          this.move(event.targetTouches[0].clientX);
        }
      }

      startMove() {
        this.isMoving = true;
      }

      endMove() {
        this.isMoving = false;
      }

      setPosition(position) {
        this.style.setProperty("--gsc-drag-position", `${position}%`);
      }

      move(newPosition) {
        const rect = this.getBoundingClientRect();
        if (newPosition <= rect.left) {
          this.setPosition(0);
        } else if (newPosition >= rect.right) {
          this.setPosition(100);
        } else {
          const position = Math.floor(((newPosition - rect.left) / this.offsetWidth) * 1000) / 10;
          this.setPosition(position);
          const positionActive = position > 50 ? "before" : "after";
          this.setAttribute("data-position-active", positionActive);
        }
      }
    }

    customElements.define("before-after-images", BeforeAfterImages);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aspadz-prod-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = "[data-aspadz-rider-reviews]";

    const init = (scope = document) => {
      scope.querySelectorAll(rootSelector).forEach((root) => {
        if (root.dataset.aspadzRiderReviewsInit === "true") return;
        root.dataset.aspadzRiderReviewsInit = "true";

        const slides = Array.from(root.querySelectorAll("[data-rider-review-slide]"));
        const tabs = Array.from(root.querySelectorAll("[data-rider-review-tab]"));
        const previousButton = root.querySelector("[data-rider-review-prev]");
        const nextButton = root.querySelector("[data-rider-review-next]");
        let activeIndex = 0;

        if (!slides.length) return;

        const syncButtons = () => {
          if (previousButton) previousButton.disabled = activeIndex <= 0;
          if (nextButton) nextButton.disabled = activeIndex >= slides.length - 1;
        };

        const toCssUrl = (url) => {
          if (!url) return "none";
          return `url("${url.replace(/"/g, "%22")}")`;
        };

        const syncBackground = () => {
          const activeSlide = slides[activeIndex];
          const desktopBackground = activeSlide?.dataset.bgDesktop || "";
          const mobileBackground = activeSlide?.dataset.bgMobile || desktopBackground;

          root.style.setProperty("--aspadz-prr-bg-desktop", toCssUrl(desktopBackground));
          root.style.setProperty("--aspadz-prr-bg-mobile", toCssUrl(mobileBackground));
        };

        const setActive = (index) => {
          activeIndex = Math.max(0, Math.min(index, slides.length - 1));

          slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === activeIndex;
            slide.classList.toggle("is-active", isActive);
            slide.hidden = !isActive;
          });

          tabs.forEach((tab, tabIndex) => {
            const isActive = tabIndex === activeIndex;
            tab.classList.toggle("is-active", isActive);
            tab.setAttribute("aria-pressed", isActive ? "true" : "false");
          });

          syncBackground();
          syncButtons();

          const activeTab = tabs[activeIndex];
          const tabsContainer = activeTab?.parentElement;
          if (activeTab && tabsContainer && typeof tabsContainer.scrollTo === "function") {
            const containerRect = tabsContainer.getBoundingClientRect();
            const tabRect = activeTab.getBoundingClientRect();
            const targetLeft = tabsContainer.scrollLeft + tabRect.left - containerRect.left - (containerRect.width - tabRect.width) / 2;
            const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

            tabsContainer.scrollTo({
              left: Math.max(0, targetLeft),
              behavior: prefersReducedMotion ? "auto" : "smooth",
            });
          }
        };

        tabs.forEach((tab) => {
          tab.addEventListener("click", () => {
            const index = Number(tab.dataset.riderReviewTab || 0);
            setActive(index);
          });
        });

        if (previousButton) {
          previousButton.addEventListener("click", () => setActive(activeIndex - 1));
        }

        if (nextButton) {
          nextButton.addEventListener("click", () => setActive(activeIndex + 1));
        }

        setActive(0);
      });
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => init(), { once: true });
    } else {
      init();
    }

    document.addEventListener("shopify:section:load", (event) => {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aspadz-prod-scene"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = "[data-aspadz-comfortmax-scene]";
    const initializedKey = "aspadzComfortmaxSceneInit";
    const mobileMedia = window.matchMedia("(max-width: 767px)");

    const clearChildren = (element) => {
      if (!element) return;
      while (element.firstChild) element.removeChild(element.firstChild);
    };

    const getData = (root) => {
      const dataElement = root.querySelector(".aspadz-product-comfortmax-scene__data");
      if (!dataElement) return null;
      try {
        return JSON.parse(dataElement.textContent || "{}");
      } catch (error) {
        return null;
      }
    };

    const setButtonState = (button, isPlaying) => {
      if (!button) return;
      const root = button.closest(rootSelector);
      const playLabel = root?.dataset.playLabel || "Play video";
      const pauseLabel = root?.dataset.pauseLabel || "Pause video";
      button.classList.toggle("is-playing", Boolean(isPlaying));
      button.setAttribute("aria-label", isPlaying ? pauseLabel : playLabel);
    };

    const hasVideoSource = (video) => {
      if (!video) return false;
      return Boolean(video.currentSrc || video.getAttribute("src") || video.querySelector("source[src]"));
    };

    const prepareVideo = (video) => {
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      video.setAttribute("playsinline", "playsinline");
      video.setAttribute("webkit-playsinline", "webkit-playsinline");
      video.removeAttribute("autoplay");
      video.preload = "metadata";
      video.loop = true;
    };

    const playVideo = (video, button, restart = false) => {
      if (!hasVideoSource(video)) {
        setButtonState(button, false);
        return;
      }

      prepareVideo(video);

      if (restart) {
        try {
          video.currentTime = 0;
        } catch (error) {}
      }

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        video.pause();
        setButtonState(button, false);
        return;
      }

      const promise = video.play();
      if (promise && typeof promise.then === "function") {
        promise.then(() => setButtonState(button, true)).catch(() => setButtonState(button, false));
      } else {
        setButtonState(button, true);
      }
    };

    const getDevice = () => mobileMedia.matches ? "mobile" : "desktop";

    const getPreferredVideoTemplate = (root, index) => {
      const templates = Array.from(root.querySelectorAll(`template[data-scene-video="${index}"]`));
      if (!templates.length) return null;
      const device = getDevice();
      const deviceTemplate = templates.find((template) => template.dataset.videoDevice === device);
      if (device === "mobile") return deviceTemplate || null;
      return deviceTemplate || templates.find((template) => template.dataset.videoDevice === "desktop") || templates[0];
    };

    const getActiveVideo = (root) => {
      return root.querySelector("[data-layer='video'] video");
    };

    const pauseAllVideos = (root) => {
      const video = getActiveVideo(root);
      if (video) video.pause();
    };

    const clearMountedImage = (mount) => {
      if (!mount) return;
      clearChildren(mount);
      delete mount.dataset.sceneImage;
    };

    const setActiveImage = (root, index) => {
      const mount = root.querySelector("[data-layer='image']");
      const activeTemplate = root.querySelector(`template[data-scene-image="${index}"]`);
      const requestedIndex = String(index);

      if (!mount) return;

      if (!activeTemplate) {
        clearMountedImage(mount);
        return;
      }

      if (mount.dataset.sceneImage === requestedIndex && mount.firstElementChild) {
        return;
      }

      clearMountedImage(mount);
      mount.appendChild(activeTemplate.content.cloneNode(true));
      mount.dataset.sceneImage = requestedIndex;
    };

    const clearMountedVideo = (mount) => {
      if (!mount) return;
      const video = mount.querySelector("video");
      if (video) video.pause();
      clearChildren(mount);
      delete mount.dataset.sceneVideo;
      delete mount.dataset.videoDevice;
    };

    const bindVideoEvents = (video, button) => {
      if (!video || video.dataset.aspadzComfortmaxSceneVideoBound === "true") return;
      video.dataset.aspadzComfortmaxSceneVideoBound = "true";
      video.addEventListener("play", () => setButtonState(button, true));
      video.addEventListener("pause", () => setButtonState(button, false));
    };

    const setActiveVideo = (root, index, shouldPlay, restart = false) => {
      const section = root.closest(".aspadz-product-comfortmax-scene");
      const videoButton = root.querySelector("[data-video-toggle]");
      const mount = root.querySelector("[data-layer='video']");
      const activeTemplate = getPreferredVideoTemplate(root, index);
      let activeVideo = getActiveVideo(root);
      const templateDevice = activeTemplate?.dataset.videoDevice || "";
      const requestedIndex = String(index);
      const shouldReuseVideo = activeVideo && mount?.dataset.sceneVideo === requestedIndex && mount?.dataset.videoDevice === templateDevice;

      if (!activeTemplate || !mount) {
        clearMountedVideo(mount);
        if (section) section.classList.remove("is-video-active");
        setButtonState(videoButton, false);
        return null;
      }

      if (!shouldPlay && !shouldReuseVideo) {
        clearMountedVideo(mount);
        if (section) section.classList.remove("is-video-active");
        setButtonState(videoButton, false);
        return null;
      }

      if (!shouldReuseVideo) {
        clearMountedVideo(mount);
        mount.appendChild(activeTemplate.content.cloneNode(true));
        mount.dataset.sceneVideo = requestedIndex;
        mount.dataset.videoDevice = templateDevice;
        activeVideo = mount.querySelector("video");
        bindVideoEvents(activeVideo, videoButton);
      }

      if (!activeVideo || !hasVideoSource(activeVideo)) {
        clearMountedVideo(mount);
        if (section) section.classList.remove("is-video-active");
        setButtonState(videoButton, false);
        return null;
      }

      prepareVideo(activeVideo);
      if (section) section.classList.add("is-video-active");

      if (shouldPlay) {
        playVideo(activeVideo, videoButton, restart);
      } else {
        setButtonState(videoButton, !activeVideo.paused);
      }

      return activeVideo;
    };

    const renderHotspots = (wrap, hotspots = []) => {
      clearChildren(wrap);
      if (!wrap || !Array.isArray(hotspots) || !hotspots.length) return;

      hotspots.forEach((hotspot, index) => {
        const x = Number(hotspot.x);
        const y = Number(hotspot.y);
        if (!Number.isFinite(x) || !Number.isFinite(y)) return;

        const item = document.createElement("div");
        item.className = "aspadz-product-comfortmax-scene__hotspot";
        item.style.left = `${x}%`;
        item.style.top = `${y}%`;
        item.style.transform = "translate(-50%, -50%)";
        item.setAttribute("aria-label", hotspot.title || `Hotspot ${index + 1}`);

        const dot = document.createElement("span");
        dot.className = "aspadz-product-comfortmax-scene__hotspot-dot";
        dot.setAttribute("aria-hidden", "true");
        item.appendChild(dot);

        const label = document.createElement("span");
        label.className = "aspadz-product-comfortmax-scene__hotspot-label";

        const text = document.createElement("span");
        text.className = "aspadz-product-comfortmax-scene__hotspot-label-text";
        text.textContent = hotspot.title || `Hotspot ${index + 1}`;
        label.appendChild(text);

        item.appendChild(label);
        wrap.appendChild(item);
      });
    };

    const initScene = (root) => {
      if (!root || root.dataset[initializedKey] === "true") return;
      root.dataset[initializedKey] = "true";

      const data = getData(root);
      const scenes = Array.isArray(data?.scenes) ? data.scenes : [];
      if (!scenes.length) return;

      const tabs = Array.from(root.querySelectorAll(".aspadz-product-comfortmax-scene__tab"));
      const videoButton = root.querySelector("[data-video-toggle]");
      const hotspots = root.querySelector("[data-layer='hotspots']");
      let currentIndex = 0;
      let isInViewport = false;
      let resizeFrame = 0;

      const setActiveTab = (index) => {
        tabs.forEach((tab) => {
          const isActive = Number(tab.dataset.scene) === index;
          tab.classList.toggle("is-active", isActive);
          tab.setAttribute("aria-selected", isActive ? "true" : "false");
        });
      };

      const renderScene = (index, restart = false) => {
        const safeIndex = Math.max(0, Math.min(index, scenes.length - 1));
        const scene = scenes[safeIndex] || {};
        currentIndex = safeIndex;
        setActiveTab(safeIndex);
        renderHotspots(hotspots, scene.hotspots || []);
        setActiveImage(root, safeIndex);
        setActiveVideo(root, safeIndex, isInViewport, restart);
      };

      tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          const index = Number(tab.dataset.scene || 0);
          renderScene(index, true);
        });
      });

      if (videoButton) {
        videoButton.addEventListener("click", () => {
          const activeVideo = getActiveVideo(root);
          if (!activeVideo || !hasVideoSource(activeVideo)) return;
          if (activeVideo.paused || activeVideo.ended) {
            playVideo(activeVideo, videoButton, activeVideo.ended);
          } else {
            activeVideo.pause();
            setButtonState(videoButton, false);
          }
        });
      }

      window.addEventListener("resize", () => {
        if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(() => {
          renderScene(currentIndex);
          resizeFrame = 0;
        });
      }, { passive: true });

      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver((entries) => {
          const isVisible = entries.some((entry) => entry.isIntersecting);
          if (isVisible === isInViewport) return;
          isInViewport = isVisible;

          if (isInViewport) {
            renderScene(currentIndex, true);
          } else {
            pauseAllVideos(root);
            setButtonState(videoButton, false);
          }
        }, { root: null, rootMargin: "0px", threshold: 0 });
        observer.observe(root);
      } else {
        isInViewport = true;
      }

      renderScene(0);
    };

    const init = (scope = document) => {
      scope.querySelectorAll(rootSelector).forEach(initScene);
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => init(), { once: true });
    } else {
      init();
    }

    document.addEventListener("shopify:section:load", (event) => {
      init(event.target);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      event.target.querySelectorAll(".aspadz-product-comfortmax-scene__video").forEach((video) => video.pause());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aspadz-prod-tour"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '.aspadz-product-guided-tour__guided';
    const videoCardSelector = '.aspadz-product-guided-tour__card--video';
    const lineSelector = '.aspadz-product-guided-tour__line';
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const easeOutCubic = (value) => 1 - Math.pow(1 - value, 3);
    const mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;
    const reducedMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    const state = new Map();
    let rafId = 0;
    let listenersReady = false;
    let popupListenersReady = false;
    let activePopupTrigger = null;

    const isMobile = () => Boolean(mobileQuery && mobileQuery.matches);
    const hasReducedMotion = () => Boolean(reducedMotionQuery && reducedMotionQuery.matches);

    const revealAt = (progress, start, length) => {
      const t = clamp((progress - start) / length, 0, 1);
      return easeOutCubic(t);
    };

    const setReadyValues = (entry) => {
      entry.section.style.setProperty('--aspadz-gt-mosaic-y', '0px');
      entry.section.style.setProperty('--aspadz-gt-line-1', '1');
      entry.section.style.setProperty('--aspadz-gt-line-2', '1');
      entry.section.style.setProperty('--aspadz-gt-line-3', '1');
    };

    const updateMetrics = () => {
      state.forEach((entry, section) => {
        if (!section.isConnected) {
          state.delete(section);
          return;
        }
        entry.lines = Array.from(section.querySelectorAll(lineSelector));
        if (!entry.lines.length) {
          entry.linesBlockHeight = 0;
          return;
        }
        const firstRect = entry.lines[0].getBoundingClientRect();
        const lastRect = entry.lines[entry.lines.length - 1].getBoundingClientRect();
        entry.linesBlockHeight = Math.max(0, lastRect.bottom - firstRect.top);
      });
    };

    const getProgress = (section) => {
      const rect = section.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      const totalFactor = isMobile() ? 0.38 : 0.54;
      const anchor = isMobile() ? 0.9 : 0.82;
      const total = rect.height + viewportHeight * totalFactor;
      const raw = (viewportHeight * anchor - rect.top) / Math.max(total, 1);
      return clamp(raw, 0, 1);
    };

    const applyFrame = (entry, progress) => {
      const lineLength = isMobile() ? 0.11 : 0.14;
      const line2Start = isMobile() ? 0.1 : 0.16;
      const line3Start = isMobile() ? 0.2 : 0.32;
      const mosaicLength = isMobile() ? 0.34 : 0.46;
      const line1 = revealAt(progress, 0, lineLength);
      const line2 = revealAt(progress, line2Start, lineLength);
      const line3 = revealAt(progress, line3Start, lineLength);
      const mosaicReveal = revealAt(progress, 0, mosaicLength);
      const mosaicY = (mosaicReveal - 1) * entry.linesBlockHeight;

      entry.section.style.setProperty('--aspadz-gt-mosaic-y', `${mosaicY}px`);
      entry.section.style.setProperty('--aspadz-gt-line-1', String(line1));
      entry.section.style.setProperty('--aspadz-gt-line-2', String(line2));
      entry.section.style.setProperty('--aspadz-gt-line-3', String(line3));
    };

    const animate = () => {
      let active = false;
      const easeFactor = isMobile() ? 0.22 : 0.18;
      state.forEach((entry) => {
        const diff = entry.targetProgress - entry.currentProgress;
        if (Math.abs(diff) > 0.0008) {
          entry.currentProgress += diff * easeFactor;
          active = true;
        } else {
          entry.currentProgress = entry.targetProgress;
        }
        applyFrame(entry, entry.currentProgress);
      });

      if (active) {
        rafId = requestAnimationFrame(animate);
      } else {
        rafId = 0;
      }
    };

    const queueAnimate = () => {
      if (hasReducedMotion()) {
        state.forEach(setReadyValues);
        return;
      }
      state.forEach((entry) => {
        entry.targetProgress = getProgress(entry.section);
      });
      if (!rafId) rafId = requestAnimationFrame(animate);
    };

    const isVisibleVideo = (video) => {
      if (!video) return false;
      const style = window.getComputedStyle(video);
      return style.display !== 'none' && style.visibility !== 'hidden' && video.clientWidth > 0 && video.clientHeight > 0;
    };

    const getActiveVideo = (card) => {
      const videos = Array.from(card.querySelectorAll('.aspadz-product-guided-tour__visual'));
      const visible = videos.find((video) => video.tagName === 'VIDEO' && isVisibleVideo(video));
      if (visible) return visible;
      return videos.find((video) => video.tagName === 'VIDEO') || null;
    };

    const pauseAllCards = (exceptCard) => {
      document.querySelectorAll(videoCardSelector).forEach((card) => {
        if (exceptCard && card === exceptCard) return;
        card.querySelectorAll('video').forEach((video) => video.pause());
        card.classList.remove('is-playing');
      });
    };

    const initVideoCards = (scope = document) => {
      scope.querySelectorAll(videoCardSelector).forEach((card) => {
        if (card.dataset.aspadzGuidedTourVideoReady === 'true') return;
        card.dataset.aspadzGuidedTourVideoReady = 'true';
        const videos = Array.from(card.querySelectorAll('video'));
        let lastTouchTs = 0;
        let lastPointerPlayTs = 0;
        let playbackToken = 0;

        videos.forEach((video) => {
          video.muted = true;
          video.playsInline = true;
          video.setAttribute('playsinline', 'playsinline');
          video.setAttribute('webkit-playsinline', 'webkit-playsinline');
          video.removeAttribute('autoplay');
          video.pause();
        });

        const playCurrent = () => {
          const video = getActiveVideo(card);
          if (!video) return;
          const token = playbackToken + 1;
          playbackToken = token;
          pauseAllCards(card);
          video.loop = !isMobile();
          const promise = video.play();
          if (promise && typeof promise.then === 'function') {
            promise.then(() => {
              if (token === playbackToken && !video.paused) {
                card.classList.add('is-playing');
              }
            }).catch(() => {});
          } else if (!video.paused) {
            card.classList.add('is-playing');
          }
        };

        const pauseCurrent = () => {
          playbackToken += 1;
          videos.forEach((video) => video.pause());
          card.classList.remove('is-playing');
        };

        videos.forEach((video) => {
          video.addEventListener('ended', pauseCurrent);
        });

        card.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          if (isMobile()) return;
          lastPointerPlayTs = Date.now();
          playCurrent();
        });

        card.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          if (isMobile()) return;
          pauseCurrent();
        });

        card.addEventListener('click', (event) => {
          if (Date.now() - lastTouchTs < 450) return;
          if (Date.now() - lastPointerPlayTs < 450) return;
          event.preventDefault();
          const video = getActiveVideo(card);
          if (!video) return;
          if (video.paused) {
            playCurrent();
          } else {
            pauseCurrent();
          }
        });

        card.addEventListener('touchend', (event) => {
          lastTouchTs = Date.now();
          event.preventDefault();
          const video = getActiveVideo(card);
          if (!video) return;
          if (video.paused) {
            playCurrent();
          } else {
            pauseCurrent();
          }
        }, { passive: false });

        card.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          const video = getActiveVideo(card);
          if (!video) return;
          if (video.paused) {
            playCurrent();
          } else {
            pauseCurrent();
          }
        });
      });
    };

    const getStickyHeader = () => document.querySelector('.section-header.shopify-section-header-sticky');

    const closePopup = (modal) => {
      if (!modal) return;
      modal.hidden = true;
      modal.querySelectorAll('[data-aspadz-guided-tour-popup-panel]').forEach((panel) => {
        panel.hidden = true;
      });
      document.documentElement.classList.remove('aspadz-product-guided-tour-modal-open');
      window.AspadzScrollLock?.unlock(modal);
      const stickyHeader = getStickyHeader();
      if (stickyHeader) {
        stickyHeader.classList.remove('aspadz-guided-tour-modal-open');
        stickyHeader.classList.remove('shopify-section-header-hidden');
      }
      if (activePopupTrigger && typeof activePopupTrigger.focus === 'function') {
        activePopupTrigger.focus({ preventScroll: true });
      }
      activePopupTrigger = null;
    };

    const openPopup = (trigger) => {
      const section = trigger.closest('.aspadz-product-guided-tour');
      if (!section) return;
      const modal = section.querySelector('[data-aspadz-guided-tour-popup]');
      if (!modal) return;
      const popupKey = trigger.getAttribute('data-aspadz-guided-tour-popup-trigger');
      const panels = Array.from(modal.querySelectorAll('[data-aspadz-guided-tour-popup-panel]'));
      const targetPanel = panels.find((panel) => panel.getAttribute('data-aspadz-guided-tour-popup-panel') === popupKey);
      if (!targetPanel) return;

      activePopupTrigger = trigger;
      panels.forEach((panel) => {
        panel.hidden = panel !== targetPanel;
      });
      modal.hidden = false;
      const stickyHeader = getStickyHeader();
      if (stickyHeader) {
        // Force show header and prevent it from auto-hiding while popup is open
        stickyHeader.classList.remove('shopify-section-header-hidden');
        stickyHeader.classList.add('aspadz-guided-tour-modal-open');
      }
      // Notify anchor-nav to recalculate after header is shown
      window.requestAnimationFrame(() => {
        window.dispatchEvent(new Event('scroll'));
      });
      window.AspadzScrollLock?.lock(modal);
      document.documentElement.classList.add('aspadz-product-guided-tour-modal-open');

      const closeButton = modal.querySelector('.aspadz-product-guided-tour__modal-close');
      if (closeButton && typeof closeButton.focus === 'function') {
        closeButton.focus({ preventScroll: true });
      }
    };

    const bindPopupListeners = () => {
      if (popupListenersReady) return;
      popupListenersReady = true;

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-aspadz-guided-tour-popup-trigger]');
        if (trigger) {
          const interactiveChild = event.target.closest('a, button, input, textarea');
          if (interactiveChild && interactiveChild !== trigger && !interactiveChild.hasAttribute('data-aspadz-guided-tour-popup-trigger')) {
            return;
          }
          event.preventDefault();
          event.stopPropagation();
          openPopup(trigger);
          return;
        }

        const closeTrigger = event.target.closest('[data-aspadz-guided-tour-popup-close]');
        if (closeTrigger) {
          event.preventDefault();
          closePopup(closeTrigger.closest('[data-aspadz-guided-tour-popup]'));
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const openModal = document.querySelector('[data-aspadz-guided-tour-popup]:not([hidden])');
          if (openModal) closePopup(openModal);
          return;
        }

        if (event.key === 'Enter' || event.key === ' ') {
          const activeEl = document.activeElement;
          if (activeEl && activeEl.matches('.aspadz-product-guided-tour__card--popup-trigger')) {
            event.preventDefault();
            openPopup(activeEl);
          }
        }
      });
    };

    const collectSections = (scope = document) => {
      scope.querySelectorAll(rootSelector).forEach((section) => {
        if (!state.has(section)) {
          state.set(section, {
            section,
            lines: [],
            linesBlockHeight: 0,
            targetProgress: 0,
            currentProgress: 0
          });
          section.classList.add('aspadz-product-guided-tour__guided--ready');
        }
      });
      updateMetrics();
    };

    const bindListeners = () => {
      if (listenersReady) return;
      listenersReady = true;
      window.addEventListener('scroll', queueAnimate, { passive: true });
      window.addEventListener('resize', () => {
        updateMetrics();
        queueAnimate();
      });
      window.addEventListener('orientationchange', () => {
        updateMetrics();
        queueAnimate();
      });
    };

    const init = (scope = document) => {
      collectSections(scope);
      initVideoCards(scope);
      bindPopupListeners();
      if (!state.size) return;
      bindListeners();
      queueAnimate();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(), { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aspadz-product-anchor-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = "[data-aspadz-product-anchor-nav]";
    const tabSelector = "[data-aspadz-anchor-tab]";
    const targetSelectors = {
      "shopify-section-aspadz-product-main": ".aspadz-product-main",
      "shopify-section-aspadz-product-specifications": ".aspadz-product-specifications",
      "shopify-section-aspadz-product-review-combo": ".aspadz-product-review-combo",
      "shopify-section-aspadz-product-faq": ".aspadz-product-faq"
    };
    const roots = new Set();
    const activeLocks = new WeakMap();
    const alignmentTokens = new WeakMap();
    const initialHashTokens = new WeakMap();
    let ticking = false;
    let headerObserver = null;
    let instantScrollRestoreFrame = 0;
    let instantScrollPreviousBehaviors = null;

    const getHeaderHeight = () => {
      const stickyHeader = document.querySelector(".section-header.shopify-section-header-sticky");
      const cssHeight = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue("--header-height")) || 0;

      if (!stickyHeader) return cssHeight;

      const isHidden =
        stickyHeader.classList.contains("shopify-section-header-hidden") &&
        !stickyHeader.classList.contains("menu-open") &&
        !stickyHeader.classList.contains("aspadz-guided-tour-modal-open");

      if (isHidden) return 0;

      // On mobile the announcement stays in document flow while only the main header is fixed.
      // Measure that visible fixed surface so the anchor bar does not reserve the scrolled-away announcement.
      const mainHeader = stickyHeader.querySelector(".aspadz-header__main");
      if (mainHeader && window.getComputedStyle(mainHeader).position === "fixed") {
        const mainHeaderHeight = mainHeader.getBoundingClientRect().height;
        if (Number.isFinite(mainHeaderHeight) && mainHeaderHeight > 0) return mainHeaderHeight;
      }

      const rectHeight = stickyHeader.getBoundingClientRect().height;
      return Number.isFinite(rectHeight) && rectHeight > 0 ? rectHeight : cssHeight;
    };

    const isPlainId = (value) => /^[A-Za-z][A-Za-z0-9\-_:.]*$/.test(value);

    const getTargetElement = (targetId) => {
      if (!targetId) return null;

      const byId = document.getElementById(targetId);
      if (byId) return byId;

      const mappedSelector = targetSelectors[targetId];
      const selector = mappedSelector || (/^[.#\[]/.test(targetId) ? targetId : "");
      if (!selector) return null;

      const element = document.querySelector(selector);
      if (!element) return null;

      if (isPlainId(targetId) && !document.getElementById(targetId)) {
        element.id = targetId;
      }

      return element;
    };

    const getTabs = (root) =>
      Array.from(root.querySelectorAll(tabSelector))
        .map((tab) => {
          const targetId = tab.dataset.aspadzAnchorTarget;
          return {
            tab,
            targetId,
            target: getTargetElement(targetId)
          };
        })
        .filter((item) => item.target);

    const updateActiveIndicator = (root) => {
      const activeTab = root.querySelector(`${tabSelector}.is-active`);
      const list = root.querySelector(".aspadz-product-anchor-nav__list");
      if (!list) return;

      if (!activeTab) {
        list.classList.remove("is-animated");
        return;
      }

      const listRect = list.getBoundingClientRect();
      const tabRect = activeTab.getBoundingClientRect();

      list.style.setProperty("--aspadz-pan-active-x", `${Math.round(tabRect.left - listRect.left)}px`);
      list.style.setProperty("--aspadz-pan-active-top", `${Math.round(tabRect.top - listRect.top)}px`);
      list.style.setProperty("--aspadz-pan-active-width", `${Math.round(tabRect.width)}px`);
      list.style.setProperty("--aspadz-pan-active-height", `${Math.round(tabRect.height)}px`);
      list.classList.add("is-animated");
    };

    const setActive = (root, targetId) => {
      root.querySelectorAll(tabSelector).forEach((tab) => {
        const isActive = tab.dataset.aspadzAnchorTarget === targetId;
        tab.classList.toggle("is-active", isActive);

        if (isActive) {
          tab.setAttribute("aria-current", "true");
        } else {
          tab.removeAttribute("aria-current");
        }
      });

      updateActiveIndicator(root);
    };

    const getScrollOffset = (root) => {
      const inner = root.querySelector(".aspadz-product-anchor-nav__inner");
      const innerRect = inner ? inner.getBoundingClientRect() : root.getBoundingClientRect();
      const stickyGap = parseFloat(window.getComputedStyle(root).getPropertyValue("--aspadz-pan-sticky-gap")) || 0;
      const isFixed = inner && window.getComputedStyle(inner).position === "fixed";
      const anchorBottom = isFixed
        ? innerRect.bottom
        : getHeaderHeight() + stickyGap + innerRect.height;

      return Math.max(0, anchorBottom) + 12;
    };

    const updateRootHeaderOffset = (root) => {
      root.style.setProperty("--aspadz-pan-visible-header-height", `${Math.round(getHeaderHeight())}px`);
    };

    const setInstantScrollTop = (top) => {
      const scrollElements = [document.documentElement, document.body].filter(Boolean);
      if (!instantScrollPreviousBehaviors) {
        instantScrollPreviousBehaviors = scrollElements.map((element) => ({
          element,
          value: element.style.getPropertyValue("scroll-behavior"),
          priority: element.style.getPropertyPriority("scroll-behavior")
        }));
      }

      scrollElements.forEach((element) => {
        element.style.setProperty("scroll-behavior", "auto", "important");
        window.getComputedStyle(element).getPropertyValue("scroll-behavior");
      });
      window.scrollTo({ top: Math.max(0, top), left: 0, behavior: "auto" });

      window.cancelAnimationFrame(instantScrollRestoreFrame);
      instantScrollRestoreFrame = window.requestAnimationFrame(() => {
        instantScrollPreviousBehaviors.forEach(({ element, value, priority }) => {
          if (value) {
            element.style.setProperty("scroll-behavior", value, priority);
          } else {
            element.style.removeProperty("scroll-behavior");
          }
        });
        instantScrollPreviousBehaviors = null;
        instantScrollRestoreFrame = 0;
      });
    };

    const updateStickyState = (root) => {
      const top = root.getBoundingClientRect().top;
      const shouldStick = top <= getHeaderHeight();
      root.classList.toggle("is-stuck", shouldStick);
    };

    const updateActiveTabs = () => {
      ticking = false;

      roots.forEach((root) => {
        if (!root.isConnected) {
          roots.delete(root);
          return;
        }

        updateRootHeaderOffset(root);
        updateStickyState(root);

        const items = getTabs(root).sort((a, b) => {
          return a.target.getBoundingClientRect().top - b.target.getBoundingClientRect().top;
        });

        if (!items.length) {
          setActive(root, null);
          return;
        }

        const activeLock = activeLocks.get(root);
        if (activeLock && activeLock.until > window.performance.now()) {
          setActive(root, activeLock.targetId);
          return;
        }

        activeLocks.delete(root);

        const offset = getScrollOffset(root);
        const activationLine = offset + Math.min(window.innerHeight * 0.3, 220);
        let active = null;

        items.forEach((item) => {
          const rect = item.target.getBoundingClientRect();
          const top = rect.top;
          const bottom = rect.bottom;

          if (top <= activationLine && bottom > offset) {
            active = item;
          }
        });

        setActive(root, active ? active.targetId : null);
      });
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateActiveTabs);
    };

    const observeHeader = () => {
      if (headerObserver || typeof MutationObserver !== "function") return;

      const header = document.querySelector(".section-header");
      if (!header) return;

      headerObserver = new MutationObserver(requestUpdate);
      headerObserver.observe(header, {
        attributes: true,
        attributeFilter: ["class", "style"]
      });
    };

    // Smooth scrolling can change the header's visible state. Re-align after scrolling settles
    // so the target consistently clears both the live header and the actual fixed tab bar.
    const stabilizeTargetAlignment = (root, target, smooth) => {
      const token = {};
      alignmentTokens.set(root, token);

      const align = () => {
        if (alignmentTokens.get(root) !== token || !root.isConnected || !target.isConnected) return;

        updateRootHeaderOffset(root);
        updateStickyState(root);

        const targetDocumentTop = target.getBoundingClientRect().top + window.pageYOffset;
        const desiredScrollTop = Math.max(0, targetDocumentTop - getScrollOffset(root));
        const delta = desiredScrollTop - window.pageYOffset;
        if (Math.abs(delta) > 0.5) {
          setInstantScrollTop(desiredScrollTop);
        }
      };

      const settle = () => {
        const settleUntil = window.performance.now() + 6000;
        let settleTimer = 0;
        let stopped = false;

        const stop = (event) => {
          if (event && !event.isTrusted) return;
          if (stopped) return;

          stopped = true;
          window.clearTimeout(settleTimer);
          window.removeEventListener("wheel", stop);
          window.removeEventListener("touchstart", stop);
          window.removeEventListener("pointerdown", stop);
          window.removeEventListener("keydown", stop);

          if (alignmentTokens.get(root) === token) {
            alignmentTokens.delete(root);
          }
        };

        const frame = () => {
          if (alignmentTokens.get(root) !== token) {
            stop();
            return;
          }

          align();
          requestUpdate();

          if (window.performance.now() < settleUntil) {
            settleTimer = window.setTimeout(frame, 80);
          } else {
            stop();
          }
        };

        window.addEventListener("wheel", stop, { passive: true });
        window.addEventListener("touchstart", stop, { passive: true });
        window.addEventListener("pointerdown", stop, { passive: true });
        window.addEventListener("keydown", stop);
        settleTimer = window.setTimeout(frame, 0);
      };

      const finish = () => {
        align();
        settle();
      };

      if (!smooth) {
        window.requestAnimationFrame(finish);
        return;
      }

      let quietTimer = 0;
      let fallbackTimer = 0;

      const cleanup = () => {
        window.removeEventListener("scroll", scheduleFinish);
        window.clearTimeout(quietTimer);
        window.clearTimeout(fallbackTimer);
      };

      const complete = () => {
        cleanup();
        finish();
      };

      const scheduleFinish = () => {
        window.clearTimeout(fallbackTimer);
        fallbackTimer = 0;
        window.clearTimeout(quietTimer);
        quietTimer = window.setTimeout(complete, 140);
      };

      window.addEventListener("scroll", scheduleFinish, { passive: true });
      fallbackTimer = window.setTimeout(complete, 3000);
    };

    const scrollToTarget = (root, targetId, smooth = true) => {
      const target = getTargetElement(targetId);
      if (!target) return false;

      setActive(root, targetId);
      activeLocks.set(root, {
        targetId,
        until: window.performance.now() + (smooth ? 1800 : 300)
      });

      const top = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset(root);
      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const shouldSmooth = smooth && !prefersReducedMotion;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: shouldSmooth ? "smooth" : "auto"
      });
      stabilizeTargetAlignment(root, target, shouldSmooth);

      return true;
    };

    // Late-loading product media can move a deep-linked section after DOMContentLoaded.
    // Re-apply the initial hash briefly, but stop as soon as the visitor starts interacting.
    const stabilizeInitialHash = (root, targetId) => {
      const token = {};
      const deadline = window.performance.now() + 10000;
      let stopped = false;
      let alignmentTimer = 0;

      initialHashTokens.set(root, token);

      const cleanup = () => {
        if (stopped) return;
        stopped = true;
        window.clearTimeout(alignmentTimer);
        window.removeEventListener("wheel", stopOnInteraction);
        window.removeEventListener("touchstart", stopOnInteraction);
        window.removeEventListener("pointerdown", stopOnInteraction);
        window.removeEventListener("keydown", stopOnInteraction);
      };

      const align = () => {
        if (stopped || initialHashTokens.get(root) !== token || !root.isConnected) {
          cleanup();
          return;
        }

        const target = getTargetElement(targetId);
        if (target) {
          updateRootHeaderOffset(root);
          updateStickyState(root);
          setActive(root, targetId);
          activeLocks.set(root, {
            targetId,
            until: window.performance.now() + 200
          });

          const targetDocumentTop = target.getBoundingClientRect().top + window.pageYOffset;
          const desiredScrollTop = Math.max(0, targetDocumentTop - getScrollOffset(root));
          const delta = desiredScrollTop - window.pageYOffset;
          if (Math.abs(delta) > 0.5) {
            setInstantScrollTop(desiredScrollTop);
          }
          requestUpdate();
        }

        if (window.performance.now() >= deadline) {
          cleanup();
          return;
        }

        alignmentTimer = window.setTimeout(align, 80);
      };

      const stopOnInteraction = (event) => {
        if (event.isTrusted) cleanup();
      };
      window.addEventListener("wheel", stopOnInteraction, { passive: true });
      window.addEventListener("touchstart", stopOnInteraction, { passive: true });
      window.addEventListener("pointerdown", stopOnInteraction, { passive: true });
      window.addEventListener("keydown", stopOnInteraction);
      align();
    };

    const bindRoot = (root) => {
      if (!root || roots.has(root)) return;

      roots.add(root);
      updateRootHeaderOffset(root);
      getTabs(root);
      updateActiveIndicator(root);

      root.querySelectorAll(tabSelector).forEach((tab) => {
        tab.addEventListener("click", (event) => {
          const targetId = tab.dataset.aspadzAnchorTarget;
          if (!targetId) return;

          event.preventDefault();
          window.history.pushState(null, "", `#${targetId}`);
          scrollToTarget(root, targetId);
        });
      });

      const initialHash = window.location.hash ? window.location.hash.slice(1) : "";
      if (initialHash) {
        stabilizeInitialHash(root, decodeURIComponent(initialHash));
      }

      requestUpdate();
    };

    const collect = (scope = document) => {
      observeHeader();
      scope.querySelectorAll(rootSelector).forEach(bindRoot);
      requestUpdate();
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => collect(), { once: true });
    } else {
      collect();
    }

    window.addEventListener("scroll", requestUpdate, { passive: true });
    window.addEventListener("resize", requestUpdate, { passive: true });
    window.addEventListener("orientationchange", requestUpdate);

    document.addEventListener("shopify:section:load", (event) => collect(event.target));
    document.addEventListener("shopify:section:unload", (event) => {
      event.target.querySelectorAll(rootSelector).forEach((root) => roots.delete(root));
      requestUpdate();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
